<script setup lang="ts">
import { computed } from 'vue'

const { overlay = false } = defineProps<{
  overlay?: boolean
}>()

const headerClasses = computed(() => ({
  'nxg-retail-pos-header--overlay': overlay,
}))
</script>

<template>
  <header class="nxg-retail-pos-header" :class="headerClasses">
    <slot />
  </header>
</template>

<style scoped>
.nxg-retail-pos-header {
  --nxg-retail-pos-header-height: 3.5rem;
  --nxg-retail-pos-betslip-width: 300px;

  width: 100%;
  min-height: var(--nxg-retail-pos-header-height);
  padding-top: var(--nxgds-alias-spacing-3xs);
  padding-left: var(--nxgds-alias-spacing-3xs);
}

.nxg-retail-pos-header > :slotted(*) {
  width: 100%;
}

.nxg-retail-pos-header--overlay {
  padding-top: 0;
  padding-left: 0;
  position: absolute;
  top: var(--nxgds-alias-spacing-3xs);
  left: var(--nxgds-alias-spacing-3xs);
  width: calc(
    100% - var(--nxg-retail-pos-betslip-width) - 3 * var(--nxgds-alias-spacing-3xs)
  );
  z-index: 1;
}
</style>
